import { useMutation } from '@tanstack/react-query';
import { linkedAccountApi } from 'api';

export const useAuthIntegration = (params?: { programId?: number; sessionId?: number; membershipId?: number }) => {
	const { mutate: addMicrosoftAccountMutate, isLoading: addMicrosoftAccountLoading } = useMutation(
		['MICROSOFT_INTEGRATION'],
		() => linkedAccountApi.addMicrosoftAccount(params),
		{
			onSuccess: (data) => {
				window.localStorage.setItem(`microsoft-auth-redirect`, window.location.pathname);
				setTimeout(() => {
					window.location.href = data.redirectUrl;
				}, 500);
			},
		}
	);

	const { mutate: addGoogleAccountMutate, isLoading: addGoogleAccountLoading } = useMutation(
		['GOOGLE_INTEGRATION'],
		() => linkedAccountApi.addGoogleAccount(params),
		{
			onSuccess: (data) => {
				window.localStorage.setItem(`google-auth-redirect`, window.location.pathname);
				setTimeout(() => {
					window.location.href = data.redirectUrl;
				}, 500);
			},
		}
	);

	return { addMicrosoftAccountMutate, addMicrosoftAccountLoading, addGoogleAccountMutate, addGoogleAccountLoading };
};
